import { render, staticRenderFns } from "./SocialSectionInstagramVideo.vue?vue&type=template&id=1bca8b45"
import script from "./SocialSectionInstagramVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialSectionInstagramVideo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports